import {
  LEVELSOFSECURITY_TABLE,
  GET_LEVELSOFSECURITY_LIST_PENDING,
  GET_LEVELSOFSECURITY_LIST_FULFILLED,
  GET_LEVELSOFSECURITY_LIST_REJECTED,
  GET_LEVELSOFSECURITY_PENDING,
  GET_LEVELSOFSECURITY_FULFILLED,
  GET_LEVELSOFSECURITY_REJECTED,
  DELETE_LEVELSOFSECURITY_FULFILLED,
  DELETE_LEVELSOFSECURITY_PENDING,
  ADD_LEVELSOFSECURITY_FULFILLED,
  UPDATE_LEVELSOFSECURITY_FULFILLED
} from '../../actions/action-constants'
const initialState = {
  title: 'Levels Of Security',
  tablename: LEVELSOFSECURITY_TABLE,
  levelsofsecurity: [],
  loadingList: false,
  errors: []
}
const reducerLevelsOfSecurity = (state = initialState, action) => {
  var dataUndefinedTestReturn
  switch (action.type) {
    case GET_LEVELSOFSECURITY_PENDING:
    case GET_LEVELSOFSECURITY_LIST_PENDING:
    case DELETE_LEVELSOFSECURITY_PENDING:
      state = {
        ...state,
        loadingList: true
      }
      break
    case GET_LEVELSOFSECURITY_LIST_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        levelsofsecurity: dataUndefinedTestReturn
      }
      break
    case GET_LEVELSOFSECURITY_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        levelsofsecurity: dataUndefinedTestReturn
      }
      break
    case DELETE_LEVELSOFSECURITY_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        deleteSuccess: true
      }
      break
    case ADD_LEVELSOFSECURITY_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        addSuccess: true
      }
      break
    case UPDATE_LEVELSOFSECURITY_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        updateSuccess: true
      }
      break
    case GET_LEVELSOFSECURITY_LIST_REJECTED:
    case GET_LEVELSOFSECURITY_REJECTED:
      state = {
        ...state,
        errors: [action.payload.response]
      }
      break
    default:
      return state
  }
  return state
}
export default reducerLevelsOfSecurity
